import { ComponentProps, FC, ReactNode } from 'react';
import { Box, Card, AnimatedShape } from '@altermaind/web/ui';

type Props = ComponentProps<typeof Card> & {
  title?: string;
  children?: ReactNode;
  isCollapsedOnDefault?: boolean;
};

export const CollapsableCardSkeleton: FC<Props> = ({ children, ...props }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Card {...props}>
      <Box display='flex' flexDirection='row' justifyContent='space-between'>
        <AnimatedShape height={30} width='40%' mr='xxxs' variant='semiRound' />
        <Box height='s'>
          <AnimatedShape width={25} height={25} variant='round' />
        </Box>
      </Box>
      {children}
    </Card>
  );
};
